import Component from 'navigation/component/Component';
import './AdaptableWrapper.scss';
export default class AdaptableWrapper extends Component {
    resizeObserver;
    constructor(el, params) {
        super(el, params);
        this.resizeObserver = new ResizeObserver(this.onResize);
    }
    bindEvents(add) {
        if (add)
            this.resizeObserver.observe(this.el?.firstElementChild);
        else
            this.resizeObserver.unobserve(this.el?.firstElementChild);
    }
    onResize = (entries) => {
        this.el.style.setProperty('--adaptable-wrapper-height', `${entries[0].contentRect.height}px`);
    };
}
